import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "mail",
  "use": "mail-usage",
  "viewBox": "0 0 794.5 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 794.5 512\" id=\"mail\"><path d=\"M761.4 0H33.1C14.8 0 0 14.8 0 33.1v445.8C0 497.2 14.8 512 33.1 512h728.2c18.3 0 33.1-14.8 33.1-33.1V33.1c.1-18.3-14.7-33.1-33-33.1zm-34.9 35L396.8 304 66.4 35h660.1zM35 457.1h.9c-.3-.1-.6-.1-.9 0zm4.6.3c2.9.6 5.8 1.8 8.3 3.9-2.5-2.1-5.4-3.4-8.3-3.9zM740.1 477v-1.2 1.2zm.1-2.9c.3-2.6 1-5.2 2.4-7.6-1.3 2.4-2.1 5-2.4 7.6zm19.3-25.2c-3.7-3.8-8.2-8.3-13.3-13.5-14.1-14.1-33.6-33.7-58.2-58.1-41.8-41.6-84.2-83.5-84.6-83.9-7.5-7.4-19.5-7.3-26.9.1-7.4 7.5-7.3 19.5.1 26.9 53 52.5 129.4 128.2 157.3 156.6H62.5c3.9-3.8 8.6-8.5 14.1-13.9 14.1-14.1 33.7-33.6 58.1-58.2 41.6-41.8 83.5-84.2 83.9-84.6 7.4-7.5 7.3-19.5-.1-26.9-7.5-7.4-19.5-7.3-26.9.1-52.5 53-128.2 129.3-156.6 157.2V58.5l349.9 284.8c3.5 2.8 7.7 4.3 12 4.3s8.5-1.4 12-4.3L759.5 57.1v391.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./sv_cms/static/assets/images/icons/mail.svg
// module id = 284
// module chunks = 6